<template>
    <b-modal size="xl" button-size="sm" v-model="showModal" :title="prefix + title" hide-footer @hidden="cancelar">

        <div v-if="loading" class="text-center my-5">
            <b-spinner label="Carregando..."></b-spinner>
        </div>

        <div v-else class="modal-body">
            <b-card bg-variant="light">
                <b-form @submit.prevent="handleSubmit">
                </b-form>
                <div class="d-flex">
                    <div class="w-50">
                        <b-table responsive style="max-height: 1000px; overflow-y: auto;" :items="this.records" rover
                            :fields="fields" :hover="true" show-empty :busy="this.busy" @row-clicked="clicouTabela">

                            <template #table-busy>
                                <div class="text-center text-primary my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                </div>
                            </template>

                            <template #empty>
                                <p>Nenhum registro encontrado</p>
                            </template>
                        </b-table>
                    </div>

                    <div class=" d-flex ml-3 ">
                        <b-tabs>
                            <b-tab title="Dados Gerais">
                                <b-card bg-variant="light">
                                    <b-form-checkbox
                                        v-if="!itemSelecionado.selecionado || (itemSelecionado && itemSelecionado.produto.tipoBem.id == 1)"
                                        :disabled="!itemSelecionado || !itemSelecionado.selecionado"
                                        v-model="itemSelecionado.relacionavel" :value="true" :unchecked-value="false">
                                        Relacionável
                                    </b-form-checkbox>

                                    <lg-form-input class="p-0"
                                        v-if="!itemSelecionado.selecionado || (itemSelecionado && itemSelecionado.produto.tipoBem.id == 1)"
                                        :disabled="!itemSelecionado || !itemSelecionado.selecionado || itemSelecionado.relacionavel"
                                        invalidFeedback=" " description="" v-model="itemSelecionado.numTombamento"
                                        label="Nº Tombamento:" />

                                    <lg-form-date class="p-0"
                                        v-if="!itemSelecionado.selecionado || (itemSelecionado && itemSelecionado.produto.tipoBem.id == 1)"
                                        :disabled="!itemSelecionado || !itemSelecionado.selecionado" invalidFeedback=" "
                                        description="" v-model="itemSelecionado.dataTombamento"
                                        label="Data Tombamento:" />

                                    <lg-form-input class="p-0"
                                        v-if="!itemSelecionado.selecionado || (itemSelecionado && itemSelecionado.produto.tipoBem.id == 1)"
                                        :disabled="!itemSelecionado || !itemSelecionado.selecionado" invalidFeedback=" "
                                        description="" v-model="itemSelecionado.numeroSerie" label="Nº Série:" />


                                    <LgFinderPageEspecificacaoProduto :produto="produto" :almoxarifado="true"
                                        :disabled="!itemSelecionado || !itemSelecionado.selecionado"
                                        id="finderLgFinderPageEspecificacaoProdutoAtesto"
                                        v-model="itemSelecionado.especificacao" label="Especificação:"
                                        :prefix="prefix + title + ' > '" @input="handleEspecificacao" />




                                    <label for="mensagem" class="form-label"
                                        style="font-size: 12px; font-family: sans-serif; color: black;">Descrição
                                        detalhada:</label>

                                    <textarea id="mensagem" :disabled="!itemSelecionado || !itemSelecionado.selecionado"
                                        invalidFeedback=" " v-model="itemSelecionado.descricao" class="form-control"
                                        rows="2" placeholder=""></textarea>

                                    <LgFinderPageAlmoxarifado :produto="produto"
                                        :disabled="!itemSelecionado || !itemSelecionado.selecionado"
                                        id="finderLgFinderPageAlmoxarifadoAtesto" v-model="itemSelecionado.almoxarifado"
                                        label="Almoxarifado:*" :prefix="prefix + title + ' > '"
                                        @onselect="handleAlmoxarifado" />

                                    <LgFinderPageLote :produto="produto" :almoxarifado="itemSelecionado.almoxarifado"
                                        :disabled="desativarLote" id="finderLgFinderPageLoteAtesto"
                                        v-model="itemSelecionado.lote" label="Lote:" :prefix="prefix + title + ' > '"
                                        @input="handleLote" />



                                    <LgFinderPageMarca :disabled="!itemSelecionado || !itemSelecionado.selecionado"
                                        id="finderPageMarcaAtestoForm" v-model="itemSelecionado.marca" label="Marca:"
                                        :prefix="[prefix + title]" @input="handleMarcaSelect" />



                                    <LgFinderPageModelo :disabled="!itemSelecionado || !itemSelecionado.selecionado"
                                        id="finderPageModeloAtestoForm" v-model="itemSelecionado.modelo" label="Modelo:"
                                        :prefix="[prefix + title]" @input="handleModeloSelect" />


                                    <LgFinderPageLocalArmazenamento id="localAtesto1"
                                        v-if="!itemSelecionado.selecionado || (itemSelecionado && itemSelecionado.produto.tipoBem.id == 2)"
                                        :disabled="!itemSelecionado || !itemSelecionado.selecionado"
                                        :prefix="prefix + title + ' > '" v-model="itemSelecionado.local1"
                                        label="Local 1:" required @input="handleLocal1" />


                                    <LgFinderPageLocalArmazenamento id="localAtesto2"
                                        v-if="!itemSelecionado.selecionado || (itemSelecionado && itemSelecionado.produto.tipoBem.id == 2)"
                                        :disabled="!itemSelecionado || !itemSelecionado.selecionado"
                                        :prefix="prefix + title + ' > '" v-model="itemSelecionado.local2"
                                        label="Local 2:" @input="handleLocal2" />


                                    <label v-if="listaDeNaturezas.length > 0" for="natureza" class="form-label"
                                        style="font-size: 12px; font-family: sans-serif; color: black;">Natureza da
                                        Despesa:*</label>

                                    <lg-form-const-select textField="descricao" valueField="id" class="pl-0 pr-0"
                                        v-if="listaDeNaturezas.length > 0" @change="mudarNatureza"
                                        v-model="naturezaSelecionadaListaConst" id="natureza"
                                        :options="listaDeNaturezas" />

                                    <LgFinderPageNatureza v-if="listaDeNaturezas.length == 0"
                                        :disabled="!itemSelecionado || !itemSelecionado.selecionado"
                                        id="finderPageNaturezaAtestoForm" @input="handleSelectNatureza"
                                        v-model="itemSelecionado.natureza" label="Natureza da Despesa:*" cols="12"
                                        :prefix="[prefix + title]" />

                                    <lg-form-date class="pl-0 pr-0 "
                                        :disabled="!itemSelecionado || !itemSelecionado.selecionado" invalidFeedback=" "
                                        description="" v-model="itemSelecionado.garantia" label="Garantia:" />

                                    <lg-form-date class="pl-0 pr-0"
                                        v-if="itemSelecionado && itemSelecionado.selecionado && itemSelecionado.produto.tipoBem.id == 2"
                                        :disabled="(!itemSelecionado || !itemSelecionado.selecionado)"
                                        invalidFeedback=" " description="" v-model="itemSelecionado.validade"
                                        label="Validade:" />

                                </b-card>
                            </b-tab>
                        </b-tabs>
                    </div>
                </div>


                <div class="d-flex justify-content-center mt-3">
                    <b-button v-if="emConferencia()" id="atesto-btn-dre" type="submit" style="height: 30px" pill
                        size="sm" @click="handleSubmit">
                        <div>
                            <b-icon icon="file-earmark-play" />
                        </div>
                        <b-tooltip target="atesto-btn-dre" title="Iniciar Atesto"></b-tooltip>
                    </b-button>
                    <b-button v-if="!emConferencia()" id="salvar-btn-dre" type="submit" variant="success"
                        style="height: 30px" pill size="sm" @click="handleSubmit">
                        <div class="btn-size-alinhamento">
                            <b-icon icon="check-circle" />
                        </div>
                        <b-tooltip target="salvar-btn-dre" title="Salvar"></b-tooltip>
                    </b-button>
                    <b-button id="cancelar-btn-dre" class="ml-2" @click="cancelar" style="height: 30px" pill size="sm"
                        variant="danger">
                        <div class="btn-size-alinhamento">
                            <b-icon icon="x-circle" />
                        </div>
                        <b-tooltip target="cancelar-btn-dre" title="Cancelar"></b-tooltip>

                    </b-button>
                </div>


            </b-card>
        </div>
    </b-modal>
</template>

<script>
import ResourceService from "@/core/api/ResourceService";
import { ListResourceMixin } from "@/core/mixins/resource";
import ConfirmMixin from "@/core/mixins/confirm";
import StatusEnum from "@/core/utils/StatusEnum";
import LgFormDate from "@/core/components/Form/LgFormDate.vue";
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import LgFinderPageNatureza from "@/components/Finders/LgFinderPageNatureza.vue"
import LgFinderPageModelo from "@/components/Finders/LgFinderPageModelo.vue"
import LgFinderPageMarca from "@/components/Finders/LgFinderPageMarca.vue"
import LgFinderPageAlmoxarifado from "@/components/Finders/LgFinderPageAlmoxarifado.vue"
import LgFinderPageLote from "@/components/Finders/LgFinderPageLote.vue"
import LgFinderPageEspecificacaoProduto from "@/components/Finders/LgFinderPageEspecificacaoProduto.vue"
import moment from "moment"
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue";
import LgFinderPageLocalArmazenamento from "@/components/Finders/LgFinderPageLocalArmazenamento.vue"


export default {
    components: {
        LgFormConstSelect,
        LgFinderPageNatureza,
        LgFinderPageModelo,
        LgFinderPageAlmoxarifado,
        LgFinderPageMarca,
        LgFinderPageLote,
        LgFinderPageEspecificacaoProduto,
        LgFormInput,
        LgFormDate,
        LgFinderPageLocalArmazenamento
    },
    computed: {
        desativarLote() {
            return !this.almoxarifado || !this.almoxarifado.id;
        },
    },
    data() {
        return {
            naturezaSelecionadaListaConst: 0,
            loading: true,
            produto: {},
            almoxarifado: {},
            natureza: {},
            saldos: [],
            listaDeNaturezas: [],
            itemSelecionado: { especificacao: {} },
            statusLocal: this.status,
            title: 'Registro de Entrada - Atesto',
            showModal: true,
            showModalAdicionar: false,
            showModalAdicionarMultiplos: false,
            busy: false,
            selectedStatusDocumento: null,
            searchText: "",
            situacao: 1,
            optionsFilterSituacao: [
                { key: "filterSituacao", text: "Todos", value: undefined },
                { key: "filterSituacao", text: "Ativo", value: 1 },
                { key: "filterSituacao", text: "Inativo", value: 0 },
            ],
            fields: [
                {
                    key: "produto.descricaoResumida", label: "Descrição", tdClass: (value, index, item) => {

                        return item.selecionado ? "text-primary" : (item.temErro ? "text-danger" : "");
                    },
                },
                {
                    key: "quantidadeRecebida",
                    label: "Quantidade",
                    tdClass: (value, index, item) => {

                        return item.selecionado ? "text-primary" : (item.temErro ? "text-danger" : "");
                    },
                },
                {
                    key: "valorRecebido", label: "Valor",
                    tdClass: (value, index, item) => {

                        return item.selecionado ? "text-primary" : (item.temErro ? "text-danger" : "");
                    },
                },
            ],
        };
    },
    mixins: [ListResourceMixin, ConfirmMixin],
    beforeMount() {
        this.$service = new ResourceService(`/api/registros-entrada`);
        this.$serviceNatureza = new ResourceService(`/api/natureza-despesa`);

        this.busy = true;
        this.loading = true;
        this.$service.get(`${this.id}/itens`).then(response => {
            this.busy = false;
            this.loading = false;

            var itens = [];

            response.data.forEach(item => {

                var novoItem = JSON.parse(JSON.stringify(item));
                if (novoItem.produto.tipoBem.id == 2) {
                    novoItem.temErro = false;
                    novoItem.selecionado = false;
                    novoItem.relacionavel = false;
                    novoItem.especificacao = {};
                    novoItem.marca = {};
                    novoItem.lote = {};
                    novoItem.modelo = {};
                    novoItem.natureza = {};
                    novoItem.almoxarifado = {};
                    itens.push(JSON.parse(JSON.stringify(novoItem)));

                }
                else

                    for (var i = 0; i < item.quantidadeRecebida; ++i) {
                        novoItem.quantidadeRecebida = 1;
                        novoItem.temErro = false;
                        novoItem.selecionado = false;
                        novoItem.relacionavel = false;
                        novoItem.especificacao = {};
                        novoItem.marca = {};
                        novoItem.lote = {};
                        novoItem.modelo = {};
                        novoItem.natureza = {};
                        novoItem.almoxarifado = {};
                        itens.push(JSON.parse(JSON.stringify(novoItem)));
                    }


            });

            this.records = itens;

        });

    },
    props: {
        prefix: {
            type: String,
            default: '',
        },
        id: {
            type: Number
        },
        status: Object
    },
    watch: {
        page() {
            this.load()
        },
    },

    methods: {
        handleLocal1(item) {
            this.itemSelecionado.local1 = item;
        },
        handleLocal2(item) {
            this.itemSelecionado.local2 = item;
        },
        handleLote(item) {
            this.itemSelecionado.lote = item;
        },
        handleAlmoxarifado(item) {
            this.itemSelecionado.almoxarifado = item;
            this.almoxarifado = item;
        },
        emConferencia() {
            return this.statusLocal.id == StatusEnum.EM_CONFERENCIA.value;
        },
        handleEspecificacao(item) {
            this.itemSelecionado.especificacao = item;
        },
        handleMarcaSelect(item) {
            this.itemSelecionado.marca = item;
        },
        handleModeloSelect(item) {
            this.itemSelecionado.modelo = item;
        },

        async confirmarMudancaNatureza(ultimaNatureza) {

            let response = await this.$confirm(
                "ND Atual: " + this.naturezaSelecionada.numero.toString() + "-" + this.naturezaSelecionada.descricao + "\nND Anterior: " + ultimaNatureza.numero + "-" + ultimaNatureza.descricao + "\n\nDeseja associar a ND atual ao item do RE?")

            if (!response) {
                this.itemSelecionado.natureza = {};
                this.naturezaSelecionadaListaConst = 0;
                return;
            }

            this.natureza = this.naturezaSelecionada;

            this.itemSelecionado.natureza = this.natureza;

            if (this.listaDeNaturezas != null && this.listaDeNaturezas.length > 0) {

                // for (var i = 0; i < this.listaDeNaturezas.length; ++i) {
                //     if (this.listaDeNaturezas[i].id == this.natureza.id) {
                //         ddlNatureza.selectedIndex = i;
                //         break;

                //     }
                // }



            }
            else {

                this.naturezaSelecionadaListaConst = 0;
                this.naturezaSelecionada = {}
                this.natureza = {};
                this.itemSelecionado.natureza = null;



            }

        },
        async mudarNatureza() {

            this.itemSelecionado.natureza = this.listaDeNaturezas.find(nat => nat.id === this.naturezaSelecionadaListaConst);
            if (this.saldos != null && this.saldos.length > 0) {
                this.naturezaSelecionada = this.itemSelecionado.natureza;
                var ultimaNatureza = this.saldos[0];

                if (this.naturezaSelecionada.id != ultimaNatureza.id) {

                    this.confirmarMudancaNatureza(ultimaNatureza);


                }
                else {
                    this.natureza = this.naturezaSelecionada;
                    this.itemSelecionado.natureza = this.natureza;

                }

            }


        },

        async handleSelectNatureza(item) {


            if (this.saldos != null && this.saldos.length > 0) {
                this.naturezaSelecionada = item;
                var ultimaNatureza = this.saldos[0];

                if (this.naturezaSelecionada.id != ultimaNatureza.id) {

                    this.confirmarMudancaNatureza(ultimaNatureza);



                } else {
                    this.natureza = this.naturezaSelecionada;
                    this.itemSelecionado.natureza = this.natureza;
                }


            }

        },

        async clicouTabela(item) {

            if (this.emConferencia())
                return;

            if (item.selecionado) {
                return;
            }
            this.records.forEach(item => {
                item.selecionado = false;
            });
            item.selecionado = true;


            this.itemSelecionado = item;

            this.produto = item.produto;
            this.almoxarifado = item.almoxarifado;

            this.loading = true;



            this.saldos = [];
            this.listaDeNaturezas = [];

            if (this.itemSelecionado.natureza && this.itemSelecionado.natureza.id)
                this.naturezaSelecionadaListaConst = this.itemSelecionado.natureza.id;
            else
                this.naturezaSelecionadaListaConst = 0;

            this.saldos = (await this.$serviceNatureza.get("buscar-saldo-itens-por-natureza/" + item.produto.id)).data;
            if (this.saldos.length == 1) {
                this.natureza.id = this.saldos[0].id;
                this.natureza.descricao = this.saldos[0].descricao;
                this.itemSelecionado.natureza = this.natureza;


            }
            else
                if (this.saldos.length > 1) {
                    var mesmaNatureza = true;

                    for (var i = 0; i < this.saldos.length - 1; ++i) {

                        if (this.saldos[i].id != this.saldos[i + 1].id) {
                            mesmaNatureza = false;
                            break;
                        }
                    }

                    if (mesmaNatureza) {
                        this.natureza.id = this.saldos[0].id;
                        this.natureza.descricao = this.saldos[0].descricao;
                        this.itemSelecionado.natureza = this.natureza;

                    } else {
                        this.listaDeNaturezas.push(...this.saldos);
                    }
                }

            this.loading = false;

        },
        closeModal() {
            this.showModal = false;
        },
        cancelar() {
            this.$emit("close");
        },
        fechar() {
            this.showModalAdicionar = false;
            this.showModalAdicionarMultiplos = false;
            this.load();
        },
        async handleSubmit() {
            if (this.emConferencia()) {
                await this.$service.put(`${this.id}/status`, { statusId: StatusEnum.ATESTANDO.value })
                this.statusLocal.id = StatusEnum.ATESTANDO.value;
                return;
            }

            var erro = false;
            this.records.forEach(item => {

                const dataTombamento = moment(String(item.dataTombamento)).format("DD/MM/YYYY");
                item.dataTombamentoFormatada = dataTombamento;

                const garantia = moment(String(item.garantia)).format("DD/MM/YYYY");
                item.garantiaFormatada = garantia;

                const validade = moment(String(item.validade)).format("DD/MM/YYYY")
                item.validadeFormatada = validade;




                item.temErro = false;

                if (!item.almoxarifado || !item.almoxarifado.id) {
                    erro = true;
                    item.temErro = true;
                }

                if (!item.natureza || !item.natureza.id) {
                    erro = true;
                    item.temErro = true;

                }

            });

            if (erro) {
                this.$notify({
                    type: "danger",
                    message: "Preencha o cadastro corretamente",
                });

                return;
            }

            try {
                await this.$service.post(`salvar`, { id: this.id, itens: this.records }).then(() => {
                    this.$notify({
                        type: "success",
                        message: "Registro salvo com sucesso",
                    });
                    this.cancelar();


                });
            }

            catch ({ response }) {
                const { data } = response;

                this.$notify({
                    type: "danger",
                    message: data,
                });

            }
        },
    },
};
</script>

<style scoped>
.text-danger {
    color: red;
}
</style>
